import { getRequest } from "../../config/axiosConfig";

export const getPatientLoginHistory = async () => {
  try {
    const response = await getRequest({
      url: process.env.REACT_APP_BASE_URL + "login-history/me",
    });

    if (response?.status === 200) {
      return {
        success: true,
        data: response,
        message: "login history retrieved Successfully!",
      };
    }
    return {
      success: false,
      data: response,
    };
  } catch (error) {
    return {
      success: false,
      data: null,
      message: "failed login history retrival request.",
    };
  }
};
